<div>
  <router-outlet></router-outlet>
</div>
<notifier-container></notifier-container>
